import SimpleIntro from "../../components/General/SimpleIntro";
import AdvancedText from "../../components/General/AdvancedText";
import AdvancesCardList from "../../components/General/AdvancesCardList";
import AdvancedIntro from "../../components/General/AdvancedIntro";

const BookingFlight = () => {
  return (
    <section>
      <SimpleIntro urlApi="services/bookingFlight/simpleIntro" />

      <div className="container text-center">
        <div style={{ margin: "7rem auto" }}>
          <AdvancedText urlApi="services/bookingFlight/advancedText" />

          <AdvancesCardList urlApi="services/bookingFlight/bookingFlightList" />
        </div>
      </div>

      <AdvancedIntro urlApi="services/bookingFlight/advancedIntro" />
    </section>
  );
};

export default BookingFlight;
